define('home/templates/settingsDeleteForm',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"form\">\n<div class=\"form__header\">\n<h1 class=\"form-heading\">"
    + alias2(helpers.gettext.call(alias1,"Delete Your %(Disqus)s Account",{"name":"gettext","hash":{"Disqus":"Disqus"},"data":data}))
    + "</h1>\n<p class=\"form-description text-gray text-medium\">"
    + alias2(helpers.gettext.call(alias1,"This can't be reversed, so make sure you're sure this is what you want.",{"name":"gettext","hash":{},"data":data}))
    + "</p>\n</div>\n<div class=\"form__content\">\n<a href=\"#\" class=\"button button-fill--brand text-medium inline__item\" data-action=\"switch-tab\" data-tab=\"delete\">"
    + alias2(helpers.gettext.call(alias1,"Delete",{"name":"gettext","hash":{},"data":data}))
    + "</a>\n</div>\n</div>\n";
},"useData":true})

});
